import { render, staticRenderFns } from "./bankAccountRemove.vue?vue&type=template&id=4bfd8c91&scoped=true&"
import script from "./bankAccountRemove.vue?vue&type=script&lang=js&"
export * from "./bankAccountRemove.vue?vue&type=script&lang=js&"
import style0 from "./bankAccountRemove.vue?vue&type=style&index=0&id=4bfd8c91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd8c91",
  null
  
)

export default component.exports